import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Hero3 from "../../components/hero3/hero3";
import HeaderBottom from "../../components/HeaderBottom/HeaderBottom";
import Quote2 from "../../components/quote2/quote2";
import CoupleSection3 from "../../components/CoupleSection3/CoupleSection3";
import StorySection3 from "../../components/StorySection3/StorySection3";
import RsvpSection from "../../components/RsvpSection/RsvpSection";
import EventSection from "../../components/EventSection/EventSection";
import PortfolioSection from "../../components/PortfolioSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const HomePage3: React.FC = () => {
  return (
    <Fragment>
      <Navbar2 hclass="header-style-s3 wpo-header-top" />
      <Hero3 />
      <HeaderBottom />
      <Quote2 />
      <CoupleSection3 />
      <StorySection3 />
      <RsvpSection rClass="pt-0" />
      <EventSection />
      <PortfolioSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default HomePage3;
